import { post, toJson, handleSerializedResponse } from 'api'
import { isCreateTokenResponseOk } from 'credit-cards/utils'

const extractValuesFromResponse = ({ CardLast4, ccToken, ExpDate, CardType }) => ({
    CardLast4,
    ccToken,
    ExpDate,
    CardType,
})

export const createCCToken = (token, CardNumber, CardExpiryMMYY, CustomerName) =>
    post(`${GRS_ACCOUNTS_SERVICE}/CreateCCToken`, {
        Token: token,
        CardNumber,
        CardExpiryMMYY,
        CustomerName,
    })
        .then(isCreateTokenResponseOk)
        .then(toJson)
        .then(handleSerializedResponse)
        .then(extractValuesFromResponse)
        .catch(error => {
            throw new Error(error.message)
        })
